// API Configuration
// Ubah BASE_URL sesuai dengan IP komputer Anda

// Production URL
export const BASE_URL = 'https://api.sewaapartementheedgebylia.my.id/api';

// Alternatif URLs (uncomment yang sesuai)
// export const BASE_URL = 'http://localhost:8000/api';
// export const BASE_URL = 'http://127.0.0.1:8000/api';
// export const BASE_URL = 'http://192.168.1.23:8000/api';

export default BASE_URL;
